export const firestoreTransactionMaxAttempts = 1
export const dexieQueryMaxAttempts = 3
export const dexieQueryRetryDelay = 500 // ms
export const logo = "/tela-logo.png"

export function getBooleanEnv(varName: string) {
   return import.meta.env[varName] === "true" || import.meta.env[varName] === "1"
}

export const isDevEnv = import.meta.env.VITE_ENVIRONMENT === "development"

export const reloadAllDatabase = isDevEnv && false

export const localDatabaseEncryptionKey = import.meta.env.VITE_LOCAL_DATABASE_ENCRYPTION_KEY

export const isSuperAdmin = localStorage.getItem("IS_SUPER_ADMIN") === "true"

export const textColors = {
   present: "#15803d",
   late: "#854d0e",
   absentJustified: "#1d4ed8",
   absentNotJustified: "#b91c1c",
}

export const chartColors = {
   present: "#22D363",
   late: "#DE8117",
   absentJustified: "#5D83E9",
   absentNotJustified: "#F14141",
}

export const DEMO_ADMIN = { email: "pierre@example.com", password: "Secret123" }
export const DEMO_JEUNE = { email: "test-1735825718439@example.com", password: "Secret123" }
